// extracted by mini-css-extract-plugin
export default {"button":"SearchBar_button__T7RTc","input":"SearchBar_input__bIy50"};